import EventRepository from '@/repositories/EventRepository'

export interface IUpdateSelectedUchinokoFacesUseCaseParams {
  eventRepository: EventRepository
}

export default class UpdateSelectedUchinokoFacesUseCase implements BaseUseCase {
  eventRepository: EventRepository

  constructor({ eventRepository }: IUpdateSelectedUchinokoFacesUseCaseParams) {
    this.eventRepository = eventRepository
  }
  // eslint-disable-next-line
  async execute(params: { eventId: number; data: { [faceId: string]: boolean } }): Promise<{ [faceId: string]: boolean }> {
    try {
      this.eventRepository.updateSelectedUchinokoFaces(params)
      return this.eventRepository.getSelectedUchinokoFaces(params.eventId)
    } catch (error) {
      throw error
    }
  }
}
